import React,{useEffect, useState} from 'react';
import close from "../assets/icons/popup_close_icon.png";
import error from "../assets/images/technical_error_icon.png";
import low_balance from "../assets/images/low_balance_icon.png";
import sad from "../assets/images/subscription_failure_icon.png"
import invalid_otp from "../assets/images/invalid_otp_icon.png";
function Modal({handleModal,modalData}) {
  const {status,title,message,btn_txt,subStatus}=modalData;
  const [imgSrc,setImgSrc]=useState("");
  useEffect(()=>
  {
    
      if(subStatus==="inactive")
      {
         setImgSrc(low_balance);
      }
      else if(status==="success")
      {   
          if(subStatus==="failed")
          {
            setImgSrc(sad)
          }
          else
          {
            setImgSrc(error)
          }
      }
      else
      {
        setImgSrc(invalid_otp)
      }
  },[])
  return (
    <div className="pop-bg">
      <div className="popup-modal">
        <img src={close} alt="close" className='model-close' onClick={() => {
          handleModal()
        }} />   
        {imgSrc && 
          <img src={imgSrc} alt="icon" className=' modal-icon'/>
        }     
          {title && <h1 className="column p-r p-0 my-4 text-lg bold">
          {title}
          </h1>}
          {message && 
          <h1 className="column p-r p-0 my-4 ">
          {message}
          </h1>}
          {btn_txt &&
           <button className='btn text-white bold' onClick={()=>handleModal()}>
            {btn_txt}
          </button> 
         }
      </div>
    </div>
  )
}

export default Modal
